import React from "react";
import JobScopeDetails from "../JobScopeDetails";
import { appointmentText, earningsText, jobPoolCopy, validEarnings } from "../jobPoolCopy";

export function assignedAppointment(destination, lang = "en") {
  if (typeof destination?.formatted_address !== "string" || !destination.formatted_address.trim()) return null;
  return appointmentText(destination, lang) || null;
}

export default function AssignedJobDetails({ job, lang = "en" }) {
  const t = jobPoolCopy[lang] || jobPoolCopy.en;
  // Only the immutable approved destination from the authenticated assignment
  // response is used. Live lead fields are not a valid destination fallback.
  const appointment = assignedAppointment(job.destination, lang);
  return <div className="space-y-3" data-testid="assigned-job-details">
    {validEarnings(job.compensation) && <p className="font-bold">{t.earnings}: {earningsText(job.compensation, lang)}</p>}
    {job.work_scope && <JobScopeDetails scope={job.work_scope} lang={lang} />}
    {appointment ? <section className="border border-white/15 rounded p-4 space-y-2" aria-label={t.confirmedDestination}>
      <h4 className="font-bold">{t.confirmedDestination}</h4><p>{job.destination.formatted_address}</p>
      <p>{t.confirmedAppointment}: {appointment}</p><p>{t.timeZone}: {job.destination.scheduled_timezone}</p>
    </section> : <p className="text-amber-200">{t.destinationMissing}</p>}
  </div>;
}
